(function(){
  var $=function(s,c){return (c||document).querySelector(s)}, $$=function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))};
  var D = document.dir==='rtl' ? -1 : 1;
  var finePointer = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  var design = !!(window.Shopify && Shopify.designMode);
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches || design;
  var hasG = !!(window.gsap && window.ScrollTrigger);
  if(hasG) gsap.registerPlugin(ScrollTrigger);

  /* ---------- Toast ---------- */
  var toast=$('#toast'), tt=$('#toastTxt'), tmr;
  function say(msg){ if(!toast) return; tt.textContent=msg; toast.classList.add('show'); clearTimeout(tmr); tmr=setTimeout(function(){toast.classList.remove('show')},2400); }
  window.kSay=say;

  /* ---------- Header ---------- */
  var head=$('#head'), lastY=0, isHome=!!$('.hero');
  function onScroll(){
    var y=window.scrollY;
    if(isHome) head.classList.toggle('solid', y>($('.hero').offsetHeight*0.12));
    if(y>lastY && y>420) head.classList.add('hide'); else head.classList.remove('hide');
    lastY=y;
  }
  if(!isHome) head.classList.add('solid');
  window.addEventListener('scroll',onScroll,{passive:true}); onScroll();

  /* ---------- Drawer ---------- */
  var drawer=$('#drawer'), menuBtn=$('#menuBtn');
  if(drawer&&menuBtn){
    menuBtn.addEventListener('click',function(){drawer.classList.add('open');drawer.setAttribute('aria-hidden','false');menuBtn.setAttribute('aria-expanded','true');if(hasG&&!reduce)gsap.from('#drawer nav a',{x:40*-D,opacity:0,stagger:.05,duration:.5,ease:'power3.out'})});
    $$('[data-close]',drawer).forEach(function(el){el.addEventListener('click',function(){drawer.classList.remove('open');drawer.setAttribute('aria-hidden','true');menuBtn.setAttribute('aria-expanded','false')})});
  }

  /* ---------- Cart / wishlist ---------- */
  var count=(window.KK&&KK.cartCount)||0, cc=$('#cartCount'); if(cc) cc.textContent=count;
  function setCount(n){ count=n; if(cc){cc.textContent=count; if(hasG) gsap.fromTo(cc,{scale:1.8},{scale:1,duration:.6,ease:'back.out(3)'});} }
  function refreshCount(){ return fetch((window.KK&&KK.routes.cart||'/cart')+'.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(function(c){setCount(c.item_count)}).catch(function(){}); }
  /* Real Shopify cart add: /cart/add.js */
  window.kAddVariant=function(id,qty,name,fromEl){
    return fetch((window.KK&&KK.routes.cartAdd)||'/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:+id,quantity:qty||1}]})})
      .then(function(r){return r.json().then(function(j){ if(!r.ok) throw j; return j; })})
      .then(function(){ refreshCount(); say((name||'القطعة')+' انضافت للسلة'); if(fromEl) flyToCart(fromEl); return true; })
      .catch(function(err){ say((err&&err.description)||'ما قدرنا نضيف القطعة، جربي مرة ثانية'); return false; });
  };
  document.addEventListener('click',function(e){
    var b=e.target.closest('.add');
    if(b && b.dataset.variant){ e.preventDefault(); var sp=b.querySelector('.lbl')||b; var old=sp.textContent; b.disabled=true;
      window.kAddVariant(b.dataset.variant,1,b.dataset.name,b).then(function(ok){ b.disabled=false; if(ok){ b.classList.add('done'); sp.textContent='انضافت للسلة'; setTimeout(function(){b.classList.remove('done');sp.textContent=old},1700);} }); return; }
    var w=e.target.closest('.wish');
    if(w){ w.classList.toggle('on'); w.setAttribute('aria-pressed',w.classList.contains('on')); say(w.classList.contains('on')?'انضافت للمفضلة':'انشالت من المفضلة'); if(hasG) gsap.fromTo(w,{scale:.7},{scale:1,duration:.5,ease:'back.out(3)'}); }
  });
  /* little dot that flies from the button to the cart icon */
  function flyToCart(from){
    if(!hasG||reduce) return; var to=$('#cartBtn'); if(!to) return;
    var a=from.getBoundingClientRect(), b=to.getBoundingClientRect();
    var dot=document.createElement('span'); dot.className='fly-dot'; document.body.appendChild(dot);
    gsap.set(dot,{x:a.left+a.width/2,y:a.top+a.height/2});
    gsap.to(dot,{x:b.left+b.width/2,y:b.top+b.height/2,duration:.75,ease:'power2.in',onComplete:function(){dot.remove()}});
    gsap.to(dot,{scale:.4,duration:.75,ease:'power1.in'});
  }

  /* ---------- Copy codes ---------- */
  $$('.copy').forEach(function(b){b.addEventListener('click',function(){
    var code=b.dataset.code;
    try{navigator.clipboard.writeText(code).then(function(){say('تم نسخ الكود '+code)},function(){say('الكود: '+code)})}catch(err){say('الكود: '+code)}
  })});

  /* ---------- Newsletter ---------- */
  $$('form.nl:not([data-shopify])').forEach(function(f){f.addEventListener('submit',function(e){e.preventDefault();var m=$('.nl-msg',f);if(m)m.textContent='تم الاشتراك، بنوصلج الجديد أول بأول.';f.reset()})});

  /* ---------- Video toggle ---------- */
  var vid=$('#heroVid'), vt=$('#vidToggle'), vi=$('#vidIcon');
  if(vt){ if(!vid){vt.style.display='none'} else vt.addEventListener('click',function(){
    if(vid.paused){vid.play();vt.setAttribute('aria-label','إيقاف الفيديو');vi.innerHTML='<rect x="6" y="5" width="4" height="14"/><rect x="14" y="5" width="4" height="14"/>'}
    else{vid.pause();vt.setAttribute('aria-label','تشغيل الفيديو');vi.innerHTML='<path d="M7 5l12 7-12 7z"/>'}
  })}

  /* ---------- Home tabs ---------- */
  $$('.tabs .tab').forEach(function(t){t.addEventListener('click',function(){
    $$('.tab',t.parentElement).forEach(function(x){x.setAttribute('aria-selected','false')}); t.setAttribute('aria-selected','true');
    var f=t.dataset.f, shown=[], scope=t.closest('section')||document;
    $$('[data-panel]',scope).forEach(function(p){ var on=p.dataset.panel===f; p.hidden=!on; if(on) shown=$$('.card',p); });
    if(hasG&&!reduce) gsap.fromTo(shown,{y:24,opacity:0},{y:0,opacity:1,duration:.6,stagger:.05,ease:'power3.out'});
    if(hasG) ScrollTrigger.refresh();
  })});

  /* ---------- Occasions ---------- */
  var steps=$$('.occ-step'), imgs=$$('.occ-media img');
  if(steps.length && 'IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(en){
      if(en.isIntersecting){var i=+en.target.dataset.step;
        steps.forEach(function(s){s.classList.toggle('on',s===en.target)});
        imgs.forEach(function(im){im.classList.toggle('on',+im.dataset.occ===i)});
      }})},{rootMargin:'-45% 0px -45% 0px'});
    steps.forEach(function(s){io.observe(s)});
  }

  /* ---------- Rails: duplicate content for seamless loop ---------- */
  $$('.rail-track').forEach(function(tr){ var kids=Array.prototype.slice.call(tr.children); kids.forEach(function(k){var c=k.cloneNode(true); c.setAttribute('aria-hidden','true'); $$('a,button',c).forEach(function(x){x.tabIndex=-1}); tr.appendChild(c)}); });
  /* ---------- Rails: auto-scroll that pauses on hover/touch and can be dragged ---------- */
  $$('.rail').forEach(function(rail){
    rail.setAttribute('data-lenis-prevent','');
    var tr=$('.rail-track',rail); if(!tr) return;
    var dir=rail.classList.contains('rev')?1:-1, speed=38, pos=0, last=0, paused=false, hold=0, drag=null, moved=false, ours=false, visible=true;
    var rtl=getComputedStyle(rail).direction==='rtl';
    function half(){ return tr.scrollWidth/2; }
    function norm(x){ var h=half(); if(!h) return x; if(rtl){ while(x<=-h) x+=h; while(x>0) x-=h; } else { while(x>=h) x-=h; while(x<0) x+=h; } return x; }
    function set(x){ pos=norm(x); ours=true; rail.scrollLeft=pos; }
    function step(t){
      var dt=last?Math.min((t-last)/1000,.05):0; last=t;
      if(visible && !paused && !drag && t>hold) set(pos+dir*speed*dt);
      requestAnimationFrame(step);
    }
    if(dir>0) set(rtl?-half()+1:half()-1);
    rail.addEventListener('scroll',function(){ if(ours){ours=false;return} pos=norm(rail.scrollLeft); if(pos!==rail.scrollLeft){ours=true;rail.scrollLeft=pos} },{passive:true});
    rail.addEventListener('pointerenter',function(e){ if(e.pointerType==='mouse') paused=true; });
    rail.addEventListener('pointerleave',function(e){ if(e.pointerType==='mouse'){ paused=false; drag=null; rail.classList.remove('dragging'); } });
    rail.addEventListener('touchstart',function(){ hold=Infinity; },{passive:true});
    rail.addEventListener('touchend',function(){ hold=performance.now()+1800; },{passive:true});
    rail.addEventListener('wheel',function(){ hold=performance.now()+1500; },{passive:true});
    rail.addEventListener('pointerdown',function(e){ if(e.pointerType!=='mouse'||e.button!==0) return; drag={x:e.clientX,s:pos}; moved=false; });
    window.addEventListener('pointermove',function(e){ if(!drag) return; var dx=e.clientX-drag.x; if(Math.abs(dx)>4){ moved=true; rail.classList.add('dragging'); } if(moved) set(drag.s-dx); });
    window.addEventListener('pointerup',function(){ if(!drag) return; drag=null; rail.classList.remove('dragging'); hold=performance.now()+800; });
    rail.addEventListener('click',function(e){ if(moved){ e.preventDefault(); e.stopPropagation(); moved=false; } },true);
    rail.addEventListener('dragstart',function(e){ e.preventDefault(); });
    if('IntersectionObserver' in window) new IntersectionObserver(function(es){ visible=es[0].isIntersecting; }).observe(rail);
    requestAnimationFrame(step);
  });

  var heroSrc=$('#heroVid source'); $$('.social-item video[data-hero]').forEach(function(v){ if(heroSrc) v.src=heroSrc.getAttribute('src'); });
  $$('.social-item video').forEach(function(v){ v.muted=true; var p=v.play&&v.play(); if(p&&p.catch)p.catch(function(){}); });


  /* ---------- Quick view (cards with options) ---------- */
  (function(){
    var fmt=(window.KK&&KK.moneyFormat)||'{{amount}}';
    function money(c){ var n=c/100; return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/,Math.round(n)).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/,n.toFixed(2).replace('.',',')).replace(/\{\{\s*amount\s*\}\}/,n.toFixed(2)).replace(/\{\{\s*[a-z_]+\s*\}\}/,n.toFixed(3)); }
    function img(u,w){ if(!u) return ''; u=u.replace(/^http:/,'https:'); return u+(u.indexOf('?')>-1?'&':'?')+'width='+w; }
    var M=null, lastFocus=null, P=null, sel=[], q=1, colors={};
    function build(){
      M=document.createElement('div'); M.className='qv'; M.id='quickView'; M.setAttribute('role','dialog'); M.setAttribute('aria-modal','true'); M.setAttribute('aria-labelledby','qvTitle'); M.setAttribute('data-lenis-prevent','');
      M.innerHTML='<div class="qv-scrim" data-qvclose></div><div class="qv-box"><button type="button" class="qv-x" data-qvclose aria-label="إغلاق"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button><div class="qv-media"><div class="qv-main"><img alt="" id="qvImg"><span class="stk-tag" id="qvStk" hidden></span></div><div class="qv-thumbs" id="qvThumbs"></div></div><div class="qv-info"><span class="eyebrow" id="qvType"></span><h2 class="display" id="qvTitle"></h2><div class="p-price" id="qvPrice"></div><div id="qvOpts"></div><div class="buy"><div class="qty"><button type="button" data-qvq="-1" aria-label="أقل">−</button><output id="qvQty">1</output><button type="button" data-qvq="1" aria-label="أكثر">+</button></div><button class="btn btn-wine" type="button" id="qvAdd"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M5 8h14l-1.2 12H6.2z"/><path d="M9 8V6a3 3 0 016 0v2"/></svg><span class="lbl">أضيفي للسلة</span></button></div><a class="qv-more" id="qvMore" href="#">شوفي كل التفاصيل</a></div></div>';
      document.body.appendChild(M);
      M.addEventListener('click',function(e){
        if(e.target.closest('[data-qvclose]')) return close();
        var o=e.target.closest('[data-oi]'); if(o){ sel[+o.dataset.oi]=o.dataset.v; render(); return; }
        var t=e.target.closest('[data-ti]'); if(t){ showImg(IM[+t.dataset.ti].src); return; }
        var qq=e.target.closest('[data-qvq]'); if(qq){ q=Math.max(1,q+ +qq.dataset.qvq); $('#qvQty',M).textContent=q; return; }
      });
      $('#qvAdd',M).addEventListener('click',function(){ var v=current(); if(!v||!v.available) return; var b=this; b.disabled=true;
        window.kAddVariant(v.id,q,P.title+(v.title&&v.title!=='Default Title'?' ('+v.title+')':''),b).then(function(ok){ b.disabled=false; if(ok) setTimeout(close,350); }); });
      document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&M.classList.contains('open')) close(); });
    }
    function current(){ return P.variants.filter(function(v){ return v.options.every(function(o,i){ return o===sel[i]; }); })[0]; }
    var IM=[];
    function norm(u){ return (u||'').replace(/^https?:/,'').split('?')[0]; }
    /* which colour each image shows: alt "... - colour", else the variant it is linked to */
    function imgList(p){
      var ci=-1; p.options.forEach(function(o,i){ if(/لون|color|colour/i.test(o.name)) ci=i; });
      var vals=ci>-1?p.options[ci].values:[], multi=vals.length>1;
      var ok={}; vals.forEach(function(c){ ok[c]=p.variants.some(function(v){ return v.available&&v.options[ci]===c; }); });
      var media=(p.media||[]).filter(function(m){ return m.media_type==='image'; });
      if(!media.length) media=p.images.map(function(u){ return {src:u,alt:''}; });
      var L=media.map(function(m){
        var c='', a=(m.alt||'').split(' - ').pop().trim();
        if(ci>-1&&vals.indexOf(a)>-1) c=a;
        if(!c&&ci>-1) p.variants.some(function(v){ if(v.featured_media&&v.featured_media.id===m.id){ c=v.options[ci]; return true; } });
        var st=!p.available?'out':(c?(ok[c]?'in':'out'):'na');
        return {src:m.src, col:c, stk:(multi||!p.available)?st:''};
      });
      if(p.available) L=L.filter(function(x){return x.stk!=='out'}).concat(L.filter(function(x){return x.stk==='out'}));
      return L;
    }
    function showImg(u){ var im=$('#qvImg',M); im.src=img(u,900); var hit=null;
      $$('#qvThumbs button',M).forEach(function(b){ var on=norm(IM[+b.dataset.ti].src)===norm(u); b.setAttribute('aria-current',on); if(on) hit=IM[+b.dataset.ti]; });
      var t=$('#qvStk',M); if(!hit||!hit.stk||hit.stk==='na'){ t.hidden=true; return; }
      if(hit.stk!=='out'){ t.hidden=true; return; } t.hidden=false; t.className='stk-tag out'; t.textContent=(hit.col?hit.col+' · ':'')+'نفد'; }
    function render(){
      var v=current();
      $('#qvOpts',M).innerHTML=P.options.map(function(o,i){
        var isC=/لون|color|colour/i.test(o.name);
        var vals=o.values.slice(); if(isC){ var okc=function(c){ return P.variants.some(function(x){ return x.available&&x.options[i]===c; }); }; vals=vals.filter(okc).concat(vals.filter(function(c){return !okc(c)})); }
        return '<div class="opt"><h3>'+o.name+': <span>'+(sel[i]||'')+'</span></h3><div class="'+(isC?'colors':'sizes')+'">'+vals.map(function(val){
          var test=sel.slice(); test[i]=val; var ok=P.variants.some(function(x){ return x.available&&x.options.every(function(oo,j){return oo===test[j]}); });
          return '<button type="button" data-oi="'+i+'" data-v="'+val.replace(/"/g,'&quot;')+'" aria-pressed="'+(sel[i]===val)+'" class="'+(ok?'':'na')+'">'+(isC&&colors[val]?'<i style="background:'+colors[val]+'"></i>':'')+val+'</button>';
        }).join('')+'</div></div>';
      }).join('');
      var pr=$('#qvPrice',M), add=$('#qvAdd',M), lbl=$('.lbl',add);
      if(!v){ add.disabled=true; lbl.textContent='اختاري من الخيارات'; var so0=$('#qvSo',M); if(so0) so0.hidden=false; return; }
      pr.innerHTML='<b>'+money(v.price)+'</b>'+(v.compare_at_price>v.price?'<s>'+money(v.compare_at_price)+'</s><span class="save">وفّري '+money(v.compare_at_price-v.price)+'</span>':'');
      add.disabled=!v.available; lbl.textContent=v.available?'أضيفي للسلة':'نفدت الكمية'; var so=$('#qvSo',M); if(so) so.hidden=v.available;
      if(v.featured_image) showImg(v.featured_image.src);
    }
    function open(handle,url,cmap,from){
      if(!M) build(); lastFocus=from;
      colors={}; (cmap||'').split('||').forEach(function(pair){ var k=pair.indexOf('::'); if(k>0) colors[pair.slice(0,k).trim()]=pair.slice(k+2).trim(); });
      M.classList.add('open','loading'); document.documentElement.classList.add('qv-lock'); if(window.kkLenis) kkLenis.stop();
      var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
      return fetch(root+'products/'+encodeURIComponent(handle)+'.js').then(function(r){ if(!r.ok) throw 0; return r.json(); }).then(function(p){
        P=p; q=1; $('#qvQty',M).textContent=1;
        var first=p.variants.filter(function(v){return v.available})[0]||p.variants[0];
        sel=first.options.slice();
        $('#qvTitle',M).textContent=p.title; var qs=document.createElement('span'); qs.className='so'; qs.id='qvSo'; qs.hidden=true; qs.textContent='نفد'; $('#qvTitle',M).appendChild(qs); $('#qvType',M).textContent=p.type||''; $('#qvMore',M).href=url;
        IM=imgList(p).slice(0,10);
        $('#qvThumbs',M).innerHTML=IM.map(function(x,i){ return '<button type="button" data-ti="'+i+'" class="'+(x.stk==='out'?'is-out':'')+'" aria-label="صورة '+(i+1)+(x.stk==='out'?' (نفد)':'')+'"><img src="'+img(x.src,160)+'" alt="" loading="lazy"></button>'; }).join('');
        showImg((first.featured_image&&first.featured_image.src)||(IM[0]&&IM[0].src)||p.images[0]); render();
        M.classList.remove('loading'); var x=$('.qv-x',M); if(x) x.focus();
        if(hasG&&!reduce) gsap.fromTo($('.qv-box',M),{y:30,opacity:0},{y:0,opacity:1,duration:.5,ease:'expo.out'});
      }).catch(function(){ close(); location.href=url; });
    }
    function close(){ if(!M) return; M.classList.remove('open','loading'); document.documentElement.classList.remove('qv-lock'); if(window.kkLenis) kkLenis.start(); if(lastFocus&&lastFocus.focus) lastFocus.focus(); }
    document.addEventListener('click',function(e){ var a=e.target.closest('a[data-qv]'); if(!a||e.metaKey||e.ctrlKey) return; e.preventDefault(); open(a.dataset.qv,a.getAttribute('href'),a.dataset.colors,a); });
  })();

  /* ---------- Page hooks (collection / product) ---------- */
  if(window.kPage) window.kPage({$:$, $$:$$, say:say, hasG:hasG, reduce:reduce, D:D});

  /* ---------- Preloader + motion ---------- */
  var pre=$('#preloader');
  var firstVisit=true; try{ firstVisit=!sessionStorage.getItem('kk_seen'); sessionStorage.setItem('kk_seen','1'); }catch(e){}

  function heroIn(){
    if(!hasG||reduce) return;
    if(isHome){
      var tl=gsap.timeline({defaults:{ease:'expo.out'}});
      tl.from('#heroFrame',{clipPath:'inset(100% 0 0 0)',duration:1.4})
        .from('#heroFrame video, #heroFrame > img',{scale:1.2,duration:1.8},0)
        .from('.hero .eyebrow',{y:20,opacity:0,duration:.8},.2)
        .from('#heroTitle .w',{yPercent:70,opacity:0,rotate:-3*D,duration:1.1,stagger:.08},.3)
        .from('.hero .lead, .hero .cta-row, .hero .pay-row',{y:24,opacity:0,duration:.9,stagger:.1},.7)
        .from('.hero-chip',{y:30,opacity:0,duration:.9},1)
        .from('.hero-sadu',{scaleY:0,transformOrigin:'top',duration:1.2,ease:'power3.inOut'},.2);
    } else {
      gsap.from('[data-intro]',{y:30,opacity:0,duration:1,stagger:.08,ease:'expo.out'});
    }
  }

  /* Preloader: drawing runs in CSS from first paint; JS only waits for it (and the page, max 2.6s) then fades out */
  function finishPre(){
    if(!pre||!pre.isConnected){heroIn();return}
    if(hasG){ gsap.to(pre,{opacity:0,duration:.5,ease:'power2.inOut',onComplete:function(){pre.remove()}}); gsap.delayedCall(.15,heroIn); }
    else { pre.style.transition='opacity .5s'; pre.style.opacity='0'; setTimeout(function(){pre.remove()},520); heroIn(); }
  }
  if(pre){
    if(reduce){ pre.remove(); heroIn(); }
    else {
      var s=parseFloat(getComputedStyle(pre).getPropertyValue('--s'))||1, done=false;
      var minT=1650*s, maxT=2600;
      var go=function(){ if(done) return; done=true; finishPre(); };
      var wait=function(){ var left=minT-performance.now(); if(left>0) setTimeout(go,left); else go(); };
      if(document.readyState==='complete') wait(); else window.addEventListener('load',wait);
      setTimeout(go,Math.max(maxT-performance.now(),minT-performance.now(),0));
    }
  } else heroIn();

  if(!hasG || reduce) return;
  var mm=gsap.matchMedia();

  /* Smooth scroll */
  var lenis=null;
  if(window.Lenis && window.matchMedia('(min-width: 901px)').matches){
    lenis=new Lenis({lerp:.09,smoothWheel:true,wheelMultiplier:.95}); window.kkLenis=lenis;
    lenis.on('scroll',ScrollTrigger.update);
    gsap.ticker.add(function(t){lenis.raf(t*1000)});
    gsap.ticker.lagSmoothing(0);
    $$('a[href^="#"]').forEach(function(a){a.addEventListener('click',function(e){var id=a.getAttribute('href');if(id.length>1&&$(id)){e.preventDefault();lenis.scrollTo(id,{offset:-80})}})});
  }

  /* Reveals */
  gsap.set('[data-reveal]',{y:28,opacity:0});
  ScrollTrigger.batch('[data-reveal]',{start:'top 92%',once:true,interval:.08,batchMax:6,onEnter:function(b){gsap.to(b,{y:0,opacity:1,duration:1.1,ease:'expo.out',stagger:.07,overwrite:true,clearProps:'transform'})}});
  /* Section titles: line rise */
  $$('.sec-head h2, .split').forEach(function(h){
    gsap.from(h,{y:24,opacity:0,duration:1.1,ease:'expo.out',scrollTrigger:{trigger:h,start:'top 90%',once:true}});
  });
  /* Image reveal (clip) */
  $$('[data-clip]').forEach(function(el){
    gsap.from(el,{clipPath:'inset(0 0 100% 0)',duration:1.3,ease:'expo.inOut',scrollTrigger:{trigger:el,start:'top 85%',once:true}});
  });
  /* Parallax */
  $$('[data-parallax]').forEach(function(el){
    gsap.to(el,{yPercent:+el.dataset.parallax,ease:'none',scrollTrigger:{trigger:el.parentElement,start:'top bottom',end:'bottom top',scrub:true}});
  });
  /* Offer track */
  if($('#trackFill')){
    gsap.from('#trackFill',{scaleX:0,duration:1.6,ease:'power2.inOut',scrollTrigger:{trigger:'.track',start:'top 80%',once:true}});
    gsap.from('.stop',{scale:0,duration:.5,ease:'back.out(2)',stagger:.35,delay:.2,scrollTrigger:{trigger:'.track',start:'top 80%',once:true}});
  }
  /* Big marquee speeds with scroll velocity */
  var bm=$('.big-mq .marquee');
  if(bm){ var skv=0, skSet=gsap.quickSetter(bm,'skewX','deg'), skCur=0; ScrollTrigger.create({trigger:'.big-mq',start:'top bottom',end:'bottom top',onUpdate:function(s){ skv=gsap.utils.clamp(-5,5,s.getVelocity()/-450); }}); gsap.ticker.add(function(){ skv*=.9; skCur+=(skv-skCur)*.12; if(Math.abs(skCur)<.01&&skCur!==0){skCur=0;} skSet(skCur); }); }

  mm.add('(min-width: 901px)', function(){
    /* Magnetic buttons */
    if(finePointer) $$('.btn:not(.btn-block)').forEach(function(b){
      if(b.closest('.buy,.qv,.modal,form')) return;
      var xT=gsap.quickTo(b,'x',{duration:.6,ease:'power3'}), yT=gsap.quickTo(b,'y',{duration:.6,ease:'power3'});
      b.addEventListener('mousemove',function(e){var r=b.getBoundingClientRect(); xT((e.clientX-r.left-r.width/2)*.15); yT((e.clientY-r.top-r.height/2)*.2)});
      b.addEventListener('mouseleave',function(){xT(0);yT(0)});
    });

  });

  /* ---------- Custom cursor (desktop) ---------- */
  if(finePointer){
    var cur=document.createElement('div'); cur.className='cursor'; cur.innerHTML='<span class="cursor-lbl"></span>';
    var dot=document.createElement('div'); dot.className='cursor-dot';
    document.body.appendChild(cur); document.body.appendChild(dot); document.documentElement.classList.add('has-cursor');
    var cx=gsap.quickTo(cur,'x',{duration:.45,ease:'power3'}), cy=gsap.quickTo(cur,'y',{duration:.45,ease:'power3'});
    var dx=gsap.quickTo(dot,'x',{duration:.08}), dy=gsap.quickTo(dot,'y',{duration:.08});
    var lbl=$('.cursor-lbl',cur);
    window.addEventListener('mousemove',function(e){cx(e.clientX);cy(e.clientY);dx(e.clientX);dy(e.clientY)});
    document.addEventListener('mouseover',function(e){
      var t=e.target.closest('[data-cursor]'), l=e.target.closest('a,button,summary,input,select,label');
      cur.classList.toggle('lbl-on',!!t); lbl.textContent=t?t.dataset.cursor:'';
      cur.classList.toggle('hover',!t&&!!l);
    });
    document.addEventListener('mouseleave',function(){gsap.to([cur,dot],{opacity:0,duration:.2})});
    document.addEventListener('mouseenter',function(){gsap.to([cur,dot],{opacity:1,duration:.2})});
  }

  /* Page transition curtain removed: the logo preloader is the only intro */

})();
